// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { change } from 'redux-form'
import getAntennaPatterns from './getAntennaPatterns'
import getAntennaPatternInfo from './getAntennaPatternInfo'

const applyModifiedAntennaSpec = antennaSpec => async (dispatch, getState) => {
  const {
    antennaSpecId,
    antennaCode,
    antennaPattern,
  } = antennaSpec

  // this is the currently active antenna details form.
  const sourceForm = getState().databaseDetails.get('sourceForm')

  // updates specified field (name) with the specified value (value)
  const updateValue = (name, value) => {
    dispatch(change(
      sourceForm,
      name,
      value
    ))
  }

  // NOTE if we're calling this here, antenna patterns should already be loaded in redux state,
  // this thunk just reuses logic that's used when initializing an antenna details form.
  const patternsFromState = await dispatch(getAntennaPatterns())

  const {
    antennaPatternId,
    patterns,
    rpeDate,
    rpeNumber,
  } = getAntennaPatternInfo({
    antennaPattern,
    patterns: patternsFromState,
    includeIds: false,
  })

  // apply the matched antenna's pattern info
  // NOTE - all ids are currently null here.
  // Once it is desired to have patterns be shared by actual reference,
  // all you need to do is set includeIds to true and the UI will then
  // assign the pattern and pattern point ids to this form.
  updateValue('antennaPatternId', antennaPatternId)
  updateValue('modifiedAntennaSpec', antennaCode)
  updateValue('modifiedAntennaSpecId', antennaSpecId)
  updateValue('patterns', patterns)
  updateValue('rpeDate', rpeDate)
  updateValue('rpeNumber', rpeNumber)
}

export default applyModifiedAntennaSpec
